// public/js/services/analysis/TrendAnalysisMethods.js
export const TrendAnalysisMethods = {
    isRising(game) {
        const trends = this.analyzeWishlistTrends(game);
        return trends.growth > 0.1 && trends.acceleration > 0;
    },

    isTrending(game) {
        const trends = this.analyzeWishlistTrends(game);
        return trends.velocity > 100; // More than 100 new wishlists per day
    },

    hasPotential(game) {
        const trends = this.analyzeWishlistTrends(game);
        const metrics = this.calculateGrowthMetrics(game);
        return trends.acceleration > 0 && metrics?.revenueGrowth > 0;
    },

    calculateAverageGrowth(games, metric = 'revenue') {
        const growthRates = games
            .map(game => {
                const history = game.history || [];
                if (history.length < 2) return 0;
                return this.calculatePercentageChange(
                    history[0][metric],
                    history[history.length - 1][metric]
                );
            })
            .filter(rate => !isNaN(rate));

        return this.calculateAverage(growthRates);
    },

    calculateGrowthDistribution(games) {
        const ranges = {
            'Declining': 0,
            'Stable': 0,
            'Growing': 0,
            'FastGrowing': 0
        };

        games.forEach(game => {
            const growth = this.calculateGrowthMetrics(game)?.revenueGrowth || 0;
            if (growth < -0.1) ranges['Declining']++;
            else if (growth < 0.1) ranges['Stable']++;
            else if (growth < 0.5) ranges['Growing']++;
            else ranges['FastGrowing']++;
        });

        return ranges;
    },

    identifyMarketTrends(games) {
        const genreTrends = {};
        const tagTrends = {};

        games.forEach(game => {
            const growth = this.calculateGrowthMetrics(game)?.revenueGrowth || 0;

            game.genres?.forEach(genre => {
                if (!genreTrends[genre]) {
                    genreTrends[genre] = { count: 0, totalGrowth: 0 };
                }
                genreTrends[genre].count++;
                genreTrends[genre].totalGrowth += growth;
            });

            game.tags?.forEach(tag => {
                if (!tagTrends[tag]) {
                    tagTrends[tag] = { count: 0, totalGrowth: 0 };
                }
                tagTrends[tag].count++;
                tagTrends[tag].totalGrowth += growth;
            });
        });

        return {
            genres: Object.entries(genreTrends)
                .map(([genre, data]) => ({
                    genre,
                    averageGrowth: data.totalGrowth / data.count,
                    gameCount: data.count
                }))
                .sort((a, b) => b.averageGrowth - a.averageGrowth),
            tags: Object.entries(tagTrends)
                .map(([tag, data]) => ({
                    tag,
                    averageGrowth: data.totalGrowth / data.count,
                    gameCount: data.count
                }))
                .sort((a, b) => b.averageGrowth - a.averageGrowth)
        };
    }
};